import { CSSProperties, ReactNode, forwardRef } from 'react'

type GradientDirections = 't' | 'b' | 'l' | 'r' | 'tr' | 'tl' | 'bl' | 'br'

interface Props {
  borderRadius?: 'default' | 'small' | 'medium' | 'large' | 'full'
  borderThickness?: number
  children: ReactNode
  gradientDirectionCx?: `bg-gradient-to-${GradientDirections}`
  gradientType?:
    | 'logo'
    | 'tutor-on-demand'
    | 'statistics'
    | 'no-gradient'
    | 'stripe-products'
    | 'stripe-products-recommended'
  innerClassName?: string
  innerStyle?: CSSProperties
  outerClassName?: string
  outerStyle?: CSSProperties
  error?: string | undefined
  isPriceCard?: boolean
}

export default forwardRef<HTMLDivElement, Props>(function ContainerHomGradientBorder(
  {
    borderThickness = 2,
    children,
    gradientDirectionCx = 'bg-gradient-to-t',
    gradientType = 'logo',
    innerClassName,
    innerStyle,
    outerClassName,
    outerStyle,
    error = '',
    isPriceCard = false,
  },
  ref,
): React.ReactElement {
  const gradientCx = error ? 'bg-red' : getGradient(gradientType)

  const containerOuterStyle = {
    borderRadius: 11,
    padding: borderThickness,
    ...outerStyle,
  }

  const containerInnerStyle = {
    borderRadius: `calc(11px - ${borderThickness}px)`,
    ...innerStyle,
  }

  return (
    <div
      className={`${gradientCx} ${gradientCx ? gradientDirectionCx : ''} ${outerClassName}`}
      ref={ref}
      style={containerOuterStyle}
    >
      <div
        className={`${isPriceCard ? 'flex max-w-full h-full max-h-full' : 'h-full'}  bg-white ${innerClassName}`}
        style={containerInnerStyle}
      >
        {children}
      </div>
    </div>
  )
})

function getGradient(
  type: 'logo' | 'tutor-on-demand' | 'statistics' | 'stripe-products' | 'no-gradient' | 'stripe-products-recommended',
): string {
  switch (type) {
    case 'logo':
      return 'from-orange-logo via-pink-logo to-blue-logo'

    case 'tutor-on-demand':
      return 'from-purple to-blue-icy'

    case 'statistics':
      return 'from-[#BE32BB] to-[#8E4FD6]'

    case 'stripe-products':
      return 'from-[#467AFF] from-3.14% via-[#FB0D98] via-59.29% to-[#FF9B05] to-97.17%'

    case 'stripe-products-recommended':
      return 'bg-pink-deep'

    case 'no-gradient':
      return ''

    default:
      return ''
  }
}
